<!-- 切换 -->
<template>
  <div class="p_flex p_column">
    <div
      v-for="(item, index) in tabbar_list"
      @click="click_tabbar(index)"
      :class="tabbar_idx === index ? 'check_style' : ''"
      class="content_right_item p_flex p_row_reverse p_align_items p_hand"
    >
      <span :class="tabbar_idx === index ? 'check_dot' : ''" class="content_right_dot"></span>
      {{ item ? $t(item) : $parent.productName }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    tabbar_idx: {
      type: Number,
      default: 0
    },
    tabbar_list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  components: {},
  created() {},
  mounted() {},
  computed: {},
  methods: {
    click_tabbar(idx) {
      this.tabbar_idx === idx ? '' : this.$emit('callback', idx);
    }
  }
};
</script>

<style scoped="scoped">
/* tabbar */
.content_right_item {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 800;
  padding: 25px 0;
  transition-property: color, fontSize;
  transition: 500ms;
}
.check_style {
  color: #fff;
  font-size: 24px;
}
.content_right_dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.5);
  margin-left: 10px;
  transition-property: background-color, width;
  transition: all 500ms;
}
.check_dot {
  background-color: #fff;
  width: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/public-switch/public-switch.vue